<template>
  <div
    class="progress-bar"
    v-if="showProgressBar">
    <ProgressBar
      :progressState="
        store.progress" />
  </div>
</template>
<script setup>
import {
 watch, nextTick, onMounted, computed,
} from 'vue';
import { useRoute } from 'vue-router';
import { gsap, CSSPlugin } from 'gsap/all';

import { useProgressStore } from '@/stores/progressStore';

import { expressCheckoutEnabled } from '@/composables/router/handleExpressCheckout';

import ProgressBar from '@/components/layout/progress/ProgressBar.vue';

gsap.registerPlugin(CSSPlugin);

const store = useProgressStore();
const route = useRoute();
const showProgressBar = computed(() => route.name !== 'order');

const animateProgressBar = (nextStep) => {
  const activeBackground = document.querySelector(
    '.progress-bar__desktop__el.PENDING .progress-bar__desktop__background',
  );

  if (!activeBackground) {
    console.warn('No active background element found for animation.');
    return;
  }

  const { offsetHeight } = activeBackground;
  const animationHeight = offsetHeight ? `${offsetHeight + 10}px` : '110%';

  gsap.timeline().to(activeBackground, {
    duration: 1,
    y: animationHeight,
    ease: 'power3.inOut',
    clearProps: 'all',
    onComplete: () => {
      store.updateToPending(nextStep);
    },
  });
};

const createProgressWatcher = (currentStep, nextStep) => {
  watch(
    () => store.progress[currentStep],
    (currentProgress) => {
      if (currentProgress === 'COMPLETE' && store.progress[nextStep] !== 'COMPLETE') {
        nextTick(() => {
          animateProgressBar(nextStep);
        });
      }
    },
  );
};

onMounted(() => {
  let progressOrder = ['verification', 'identity', 'payment'];
  if (expressCheckoutEnabled()) { progressOrder = ['payment', 'verification', 'identity']; }
  createProgressWatcher(progressOrder[0], progressOrder[1]);
  createProgressWatcher(progressOrder[1], progressOrder[2]);
});

</script>
<style lang="scss">
.progress-bar {
  width: 100%;
  max-width: 54rem;
  margin: 0 auto;
  padding: 2.4rem 3.4rem;
}
</style>
